export const GET_EMAIL_BY_CODE = (code) => `${process.env.REACT_APP_ENDPOINT_RECOVERY}/${code}`;
export const POST_RESET_PASSWORD_USER = (idUser) => `${process.env.REACT_APP_ENDPOINT_RECOVERY}/${idUser}`
